<script setup>
import { SelectValue } from "reka-ui";
import { cn } from "@/shared/lib/utils";

const props = defineProps({
  placeholder: { type: String, default: undefined },
  class: { type: [String, Object, Array], default: undefined },
});
</script>

<template>
  <SelectValue
    :placeholder="placeholder"
    data-slot="select-value"
    :class="cn('overflow-hidden text-ellipsis whitespace-nowrap', props.class)"
  >
    <slot />
  </SelectValue>
</template>
